import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { ICollector, ICollectors } from '@GFTypes/GameStoreTypes/SpinOutcome';
import { ICollectorResponseData } from '@GFTypes/Responses/ActionResponse';
import { IDefaultCollectorResponseData } from '@GFTypes/Responses/AuthenticateResponse';

const getCollectorsPerBetMap = (collectors: ICollector[]): Map<number, ICollector[]> => {
    return collectors.reduce((map, collector) => {
        if (collector.bet === undefined) return map;

        const list = map.get(collector.bet) ?? [];
        list.push(collector);
        map.set(collector.bet, list);

        return map;
    }, new Map<number, ICollector[]>());
};

const addCollectorId = (collectorsPerBet: Map<number, ICollector[]>): void => {
    collectorsPerBet.forEach((betCollection) => {
        betCollection.forEach((collector, index) => (collector.id = index + 1));
    });
};

const getCollectorsFromDefault = (collectorData: ICollectorResponseData[], defaultCollectors: IDefaultCollectorResponseData[]): ICollectorResponseData[] => {
    const perBetCollectors = defaultCollectors.every((collector) => collector.perBet);
    const bets = gameInstance.gameStore.get(EGameStoreKeys.BetState).betSteps;
    let collectors: ICollectorResponseData[] = collectorData ?? [];
    if (perBetCollectors) {
        bets.forEach((bet) => {
            const hasCollectorForBet = !!collectorData.filter((collector) => collector.bet === bet.raw).length;
            if (!hasCollectorForBet) {
                collectors.push(
                    ...defaultCollectors.map((defaultCollector) => ({
                        bet: bet.raw,
                        total: defaultCollector.total,
                        current: defaultCollector.start,
                        symbolIds: defaultCollector.symbolIds,
                        reelIndex: defaultCollector.reelIndex
                    }))
                );
            }
        });
    } else if (collectors.length === 0) {
        collectors = [];
        collectors.push(
            ...defaultCollectors.map((defaultCollector) => ({
                total: defaultCollector.total,
                current: defaultCollector.start,
                symbolIds: defaultCollector.symbolIds,
                reelIndex: defaultCollector.reelIndex
            }))
        );
    }

    return collectors;
};

export const processCollectorData = (collectorData: ICollectorResponseData[], defaultCollectors: IDefaultCollectorResponseData[] | undefined): ICollectors => {
    const clone = structuredClone(collectorData);
    const preProcessedCollectors = defaultCollectors ? getCollectorsFromDefault(clone, defaultCollectors) : clone;
    const collectorsPerBet = getCollectorsPerBetMap(preProcessedCollectors);
    const bets = gameInstance.gameStore.get(EGameStoreKeys.BetState).betSteps;
    const collectors: ICollector[] = [];

    addCollectorId(collectorsPerBet);

    if (collectorsPerBet.size > 0) {
        bets.forEach((bet) => {
            if (!collectorsPerBet.get(bet.raw)) {
                const emptyCollectors = collectorsPerBet.get(preProcessedCollectors[0].bet!)!.map((collector, index) => ({ ...collector, id: index + 1 }));
                collectorsPerBet.set(bet.raw, [...emptyCollectors]);
            }
        });
    } else {
        collectors.push(...preProcessedCollectors.map((collector, index) => ({ ...collector, id: index + 1 })));
    }

    return { collectors, collectorsPerBet };
};
